module.exports = __webpack_public_path__ + "static/media/new-header.56450d53.png";